import { customerApiClient } from './customer-api-client';
import type {
  CustomerEquipmentDetail,
  CustomerEquipmentListData,
  CustomerEquipmentListQuery,
} from '@/types/customer-equipment.types';

export const customerEquipmentService = {
  list: (query: CustomerEquipmentListQuery): Promise<CustomerEquipmentListData> =>
    customerApiClient
      .get<CustomerEquipmentListData>('/customer-portal/equipment', { params: query })
      .then((r) => r.data),

  getById: (id: string): Promise<CustomerEquipmentDetail> =>
    customerApiClient
      .get<CustomerEquipmentDetail>(`/customer-portal/equipment/${id}`)
      .then((r) => r.data),
};
